const textProps = {
  image: require("assets/img/guitar-play.jpg").default,
  subtitle: "All the beautiful places",
  title: "Research by Bang & Olufsen on city sounds and music",
  size: "lg",
  link: { href: "#pablo" },
};
export default textProps;
